var _a, _b, _c;
import React from 'react';
import { globalThisPolyfill } from '@formily/shared';
var env = {
    portalDOM: (_b = (_a = globalThisPolyfill === null || globalThisPolyfill === void 0 ? void 0 : globalThisPolyfill.document) === null || _a === void 0 ? void 0 : _a.createElement) === null || _b === void 0 ? void 0 : _b.call(_a, 'div'),
    createPortal: (_c = globalThisPolyfill === null || globalThisPolyfill === void 0 ? void 0 : globalThisPolyfill['ReactDOM']) === null || _c === void 0 ? void 0 : _c.createPortal,
};
/* istanbul ignore next */
var loadCreatePortal = function () {
    var _a, _b;
    if (!env.createPortal) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            (_a = env.createPortal) !== null && _a !== void 0 ? _a : (env.createPortal = (_b = require('react-dom')) === null || _b === void 0 ? void 0 : _b.createPortal);
        }
        catch (_c) { }
    }
    if (!env.createPortal) {
        try {
            // @ts-ignore
            import('react-dom')
                .then(function (module) { var _a; return ((_a = env.createPortal) !== null && _a !== void 0 ? _a : (env.createPortal = module === null || module === void 0 ? void 0 : module.createPortal)); })
                .catch();
        }
        catch (_d) { }
    }
};
export var render = function (element) {
    var _a;
    if (((_a = globalThisPolyfill.navigator) === null || _a === void 0 ? void 0 : _a.product) === 'ReactNative')
        return null;
    if (env.portalDOM && env.createPortal) {
        return env.createPortal(element, env.portalDOM);
    }
    else {
        return React.createElement('template', {}, element);
    }
};
loadCreatePortal();
//# sourceMappingURL=render.js.map